import React from 'react';
import { Gift, Loader2 } from 'lucide-react';

import { Card } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';

export default function CheckoutRewardsSection({
  checkoutRewardChoice,
  setCheckoutRewardChoice,
  benefitsProgressLoading,
  referralInfoLoading,
  clubPremioDisponible,
  clubPremioLabel,
  referralPremioDisponible,
  referralPremioLabel,
}) {
  return (
    <Card className="p-6 border-primary/25 shadow-sm bg-gradient-to-br from-primary/5 via-background to-background">
      <h2 className="text-xl font-semibold mb-1 flex items-center gap-2">
        <Gift className="w-5 h-5 text-primary shrink-0" />
        Usar un premio disponible
      </h2>
      <p className="text-sm text-muted-foreground mb-4">
        Un solo premio por pedido. Elige club de beneficios o premio por referidos. El local aplica el
        beneficio en tu compra.
      </p>
      {benefitsProgressLoading || referralInfoLoading ? (
        <p className="text-sm text-muted-foreground flex items-center gap-2">
          <Loader2 className="w-4 h-4 animate-spin shrink-0" />
          Cargando premios disponibles…
        </p>
      ) : (
        <RadioGroup value={checkoutRewardChoice} onValueChange={setCheckoutRewardChoice}>
          <div className="flex items-start space-x-3 p-3 border rounded-lg bg-card">
            <RadioGroupItem value="none" id="checkout-reward-none" className="mt-0.5" />
            <Label htmlFor="checkout-reward-none" className="font-normal cursor-pointer leading-snug">
              No canjear un premio en este pedido
            </Label>
          </div>
          {clubPremioDisponible ? (
            <div className="flex items-start space-x-3 p-3 border rounded-lg bg-card border-dashed mt-3">
              <RadioGroupItem value="club" id="checkout-reward-club" className="mt-0.5" />
              <Label htmlFor="checkout-reward-club" className="font-normal cursor-pointer leading-snug flex-1">
                <span className="font-semibold text-foreground">Club de beneficios</span>
                <span className="block text-sm text-muted-foreground mt-0.5">{clubPremioLabel}</span>
              </Label>
            </div>
          ) : null}
          {referralPremioDisponible ? (
            <div className="flex items-start space-x-3 p-3 border rounded-lg bg-card border-dashed mt-3">
              <RadioGroupItem value="referral" id="checkout-reward-referral" className="mt-0.5" />
              <Label
                htmlFor="checkout-reward-referral"
                className="font-normal cursor-pointer leading-snug flex-1"
              >
                <span className="font-semibold text-foreground">Premio por referidos</span>
                <span className="block text-sm text-muted-foreground mt-0.5">{referralPremioLabel}</span>
              </Label>
            </div>
          ) : null}
        </RadioGroup>
      )}
    </Card>
  );
}
